
function salvarCredenciais(usuario: string, senha: string) {
    window.sessionStorage.setItem("usuario", usuario);
    window.sessionStorage.setItem("senha", senha);
}

function obterUsuarioSessao(): string | undefined {
    return window.sessionStorage.getItem("usuario")?.toString();
}

function obterSenhaSessao(): string | undefined {
    return window.sessionStorage.getItem("senha")?.toString();
}

function usuarioLogado(): boolean {
    return window.sessionStorage.getItem("usuario") != null && window.sessionStorage.getItem("senha") != null;
}

function deslogarSessao() {
    window.sessionStorage.clear();
}

export {
    salvarCredenciais,
    obterUsuarioSessao,
    obterSenhaSessao,
    usuarioLogado,
    deslogarSessao,
}